import { Button, ButtonProps } from '@xingternal/button';
import React from 'react';
import { useTracking } from '@/hooks/useTracking';

export interface BaseButtonProps extends ButtonProps {
  trackingAttributes?: Record<string, string>;
}

export const BaseButton: React.FC<BaseButtonProps> = ({
  trackingAttributes,
  onClick,
  ...props
}) => {
  const { generateHandleTracking } = useTracking();
  const handleTracking = generateHandleTracking({
    onClick,
    to: props.to,
    href: props.href,
    target: props.target,
    trackingAttributes,
  });

  const handleClick = trackingAttributes ? handleTracking : onClick;

  return <Button {...{ ...props, onClick: handleClick }} />;
};

export default BaseButton;
